export default __webpack_public_path__ + "static/media/img-bombom-signup.8fc21f55.png";